import { dmyToYmd } from './reportDateParams'
import type { PmcPerformanceListPatch } from '../types/utils'
import { PMC_PERFORMANCE_SESSION_KEY } from '../constants/sessionKeys'

export { PMC_PERFORMANCE_SESSION_KEY }

export function readPmcPerformanceSession(): Record<string, unknown> | null {
  try {
    const raw = sessionStorage.getItem(PMC_PERFORMANCE_SESSION_KEY)
    if (!raw) return null
    const v = JSON.parse(raw) as unknown
    return typeof v === 'object' && v !== null && !Array.isArray(v) ? (v as Record<string, unknown>) : null
  } catch {
    return null
  }
}

export function writePmcPerformanceSession(data: Record<string, unknown>): void {
  sessionStorage.setItem(PMC_PERFORMANCE_SESSION_KEY, JSON.stringify(data))
}

export function clearPmcPerformanceSession(): void {
  sessionStorage.removeItem(PMC_PERFORMANCE_SESSION_KEY)
}

function normalizeStoredDate(value: unknown): string {
  if (value == null) return ''
  const s = String(value).trim()
  if (!s) return ''
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s
  return dmyToYmd(s) || s
}

export function sessionFilterToPmcPerformancePatch(
  session: Record<string, unknown>,
): PmcPerformanceListPatch {
  const patch: PmcPerformanceListPatch = {}
  if (typeof session.page === 'number' && session.page > 0) patch.page = session.page
  if (typeof session.perPage === 'number' && session.perPage > 0) patch.perPage = session.perPage
  if (session.sortBy === 'asc' || session.sortBy === 'desc') patch.sortBy = session.sortBy
  if (typeof session.orderBy === 'string' && session.orderBy.trim()) patch.orderBy = session.orderBy
  const fromDt = normalizeStoredDate(session.fromDt)
  const toDt = normalizeStoredDate(session.toDt)
  if (fromDt) patch.fromDt = fromDt
  if (toDt) patch.toDt = toDt
  if (session.company_id != null && session.company_id !== '') {
    patch.company_id = String(session.company_id)
  }
  if (typeof session.company_name === 'string') patch.company_name = session.company_name
  if (Array.isArray(session.sales_team)) {
    patch.sales_team = session.sales_team.map(String)
  } else if (typeof session.sales_team === 'string' && session.sales_team) {
    patch.sales_team = [session.sales_team]
  }
  return patch
}

export function buildPmcPerformanceSessionFromParams(p: {
  page: number
  perPage: number
  sortBy: string
  orderBy: string
  fromDt: string
  toDt: string
  company_id: string
  company_name: string
  sales_team: string[]
}): Record<string, unknown> {
  const out: Record<string, unknown> = {
    page: p.page,
    perPage: p.perPage,
    sortBy: p.sortBy,
    orderBy: p.orderBy,
    sales_team: p.sales_team,
  }
  if (p.fromDt) out.fromDt = p.fromDt
  if (p.toDt) out.toDt = p.toDt
  if (p.company_id) {
    out.company_id = p.company_id
    if (p.company_name) out.company_name = p.company_name
  }
  return out
}
